import { frontendURL } from '../../../helper/URLHelper';

const ClaudiaLayout = () => import('./components/ClaudiaLayout.vue');
const EddieView = () => import('../eddie/pages/EddieView.vue');
const KnowledgeBaseMicrofrontend = () =>
  import(
    '../../../../microfrontends/knowledge-base/KnowledgeBaseMicrofrontend.vue'
  );
const ClaudiaAgentsView = () => import('./pages/ClaudiaAgentsView.vue');
const ClaudiaToolsView = () => import('./pages/ClaudiaToolsView.vue');
const ClaudiaMcpView = () => import('./pages/ClaudiaMcpView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/claudia'),
      name: 'claudia_app',
      component: ClaudiaLayout,
      meta: {
        permissions: ['administrator', 'cx_engineer'],
      },
      children: [
        {
          path: '',
          redirect: 'view',
        },
        {
          path: 'view',
          name: 'eddie_view',
          component: EddieView,
          meta: { permissions: ['administrator', 'cx_engineer'] },
        },
        {
          path: 'knowledge-bases',
          name: 'knowledge_base_view',
          component: KnowledgeBaseMicrofrontend,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
            newFeatureFlag: 'enable_knowledge_bases',
          },
        },
        {
          path: 'knowledge-bases/*',
          name: 'knowledge_base_view_catchall',
          component: KnowledgeBaseMicrofrontend,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
            newFeatureFlag: 'enable_knowledge_bases',
          },
        },
        {
          path: 'agents',
          name: 'claudia_agents',
          component: ClaudiaAgentsView,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
          },
        },
        {
          path: 'tools',
          name: 'claudia_tools',
          component: ClaudiaToolsView,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
          },
        },
        {
          path: 'mcp',
          name: 'claudia_mcp',
          component: ClaudiaMcpView,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
          },
        },
      ],
    },
  ],
};
